import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RestrictionsComponent} from './restrictions.component';
import * as angular from 'angular';

angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/restrictions', {template: ''});
    }]);
/***/

const RestrictionsRoutes: Routes = [
    {path: 'company/:id/restrictions', component: RestrictionsComponent},
    {path: 'cars-sara-v2/web/company/:id/restrictions', component: RestrictionsComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(RestrictionsRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class RestrictionsRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/restrictions-routing.module.ts